<template>
  <div class="grid-images" v-if="uniqueNumbers">
    <img class="image" :src="payload[uniqueNumbers[0]]" alt="" loading="lazy">
    <img class="image" :src="payload[uniqueNumbers[1]]" alt="" loading="lazy">
  </div>
</template>

<script>

  export default {
    name: 'transitionImage',

   	props: {
      payload: {
        type: Array,
        required: true
      }
		},

   	data() {
      return {

      }
    },

    mounted() {

    },

    beforeDestroy() {
;
    },

    methods: {
     
    }
  };
</script>
